import { dailySessionNotes } from '../../actions/constant';

const { SUCCESS_SUBMIT_E_SIGN, FAILURE_SUBMIT_E_SIGN, RESET_SUBMIT_E_SIGN, LOADING_SUBMIT_E_SIGN } =
  dailySessionNotes;

const intitialstate: object = {
  response: null,
  isSubmitted: false,
  loading: false,
};

export const submitEsignReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_SUBMIT_E_SIGN: {
      return {
        ...state,
        isSubmitted: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_SUBMIT_E_SIGN:
      return {
        ...state,
        isSubmitted: false,
        response: action.payload,
        loading: false,
      };

    case LOADING_SUBMIT_E_SIGN:
      return {
        ...state,
        loading: true,
      };

    case RESET_SUBMIT_E_SIGN:
      return intitialstate;

    default:
      return state;
  }
};
